export default __webpack_public_path__ + "static/media/ipadDemo.60b558a5.webp";